import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "../runtime/RuntimeContext";

/**
 * Available workflow transitions for a record at its CURRENT stage. Backend
 * filters by guard (RBAC + custom predicates) so the list reflects what THIS
 * principal can actually do. Re-fetched on field-level writes via React
 * Query's invalidation key ["workflow-transitions", model, recordUuid] so a
 * transition that flips the stage causes the next set of transitions to load.
 */
export function useWorkflowTransitions(modelKey: string, recordUuid: string | null, enabled = true) {
    const runtime = useRuntime();
    return useQuery({
        queryKey: ["workflow-transitions", modelKey, recordUuid ?? ""],
        queryFn: () => runtime.services.workflow.available(modelKey, String(recordUuid)),
        // Only fire when we have a real record id (skip on "new" or empty).
        enabled: enabled && Boolean(recordUuid) && recordUuid !== "new",
        staleTime: 30_000,
    });
}
